import { useFlag } from 'toggled'

import { flags } from '~/utils/constants'

export const useDynamicPageLimit = () => {
  const advancedFiltersFF = useFlag(flags.ADVANCED_FILTERS)

  const showcartinmainlayoutFF = useFlag(flags.SHOW_CART_IN_MAIN_LAYOUT)

  const active = Number(advancedFiltersFF) + Number(showcartinmainlayoutFF)

  if (active === 0) return 25

  if (active === 1) return 20

  return 15
}
